<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoaderView',
  props: {
    loading: Boolean,
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
})
</script>

<template>
  <div class="loader-container">
    <div class="loader-spinner">
      <svg class="spinner" viewBox="0 0 50 50">
        <circle
          class="path"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke-width="5"
        />
      </svg>
    </div>
    <div class="content">
      <h3>{{ title }}</h3>
      <p>{{ description }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px;
  border-radius: 12px;
  gap: 24px;
  background: #ffffff;
  box-shadow: 0 4px 16px 0 #10083f1f;

  & .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    & h3 {
      font-weight: bold;
      font-size: 28px;
    }
    & p {
      font-size: 14px;
      text-align: center;
    }
  }

  .loader-spinner {
    .spinner {
      animation: rotate 2s linear infinite;
      z-index: 2;
      top: 50%;
      left: 50%;
      margin: -25px 0 0 -25px;
      width: 104px;
      height: 104px;

      & .path {
        stroke-width: 2px;
        stroke: var(--color-yellow-active);
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
      }
    }
  }
}
@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
}

@media screen and (max-width: 500px) {
  .loader-container {
    padding: 0;
    border: none;
    box-shadow: none;
    display: flex;
    flex-direction: column;
    gap: 48px;
    .content {
      & h3 {
        font-size: 24px;
      }
      & p {
        font-size: 14px;
        text-align: center;
      }
    }
    .loader-spinner {
      .spinner {
        margin: 0;
        width: 104px;
        height: 104px;
      }
    }
  }
}

@media screen and (min-width: 560px) {
  .loader-container {
    max-width: 520px;
  }
}
</style>
